import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Handler} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {StartGuideFooterLink} from './startGuideFooterLink';

/*
 * Props.
 */

interface StartGuideFooterLinksProps {
  onOpenHelpChatClick: Handler;
  onOpenBlogClick: Handler;
}

/*
 * Style.
 */

const StyledStartGuideFooterDiv = styled.div`
  display: grid;
  grid-auto-columns: 1fr;
  grid-auto-flow: column;
  grid-column-gap: 10px;
  padding: 18px 16px 20px;
`;

/*
 * Component.
 */

export const StartGuideFooterLinks: FC<StartGuideFooterLinksProps> = (props) => (
  <StyledStartGuideFooterDiv>
    <StartGuideFooterLink onClick={props.onOpenBlogClick} iconName="externalLinkSmall">
      <Trans id="start-guide-header-helpcenter">Our blog</Trans>
    </StartGuideFooterLink>
    <StartGuideFooterLink onClick={props.onOpenHelpChatClick} iconName="discussionSmall">
      <Trans id="start-guide-header-helpchat">Talk to us</Trans>
    </StartGuideFooterLink>
  </StyledStartGuideFooterDiv>
);
